import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { getSortOptionForSearch } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomSortController';
import { changeTimeForSearch, convertApiString, shouldChangeFilterTypes, updateSearchDataForApps }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomSearchController';
import { saveSearchInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";

export const searchStart = (type) => {
    return {
        type: actionTypes.SEARCH_START,
        payload: { type: type }
    }
}
export const searchFail = (error) => {
    return {
        type: actionTypes.SEARCH_FAIL,
        error: error
    }
}
export const searchSuccess = (result, type = 'search') => {
    return {
        type: actionTypes.SEARCH_SUCCESS,
        payload: { clips: result, type: type }
    }
}
export const searchNextStart = () => {
    return {
        type: actionTypes.SEARCH_NEXT_START
    }
}
export const searchNextFail = (error) => {
    return {
        type: actionTypes.SEARCH_NEXT_FAIL,
        error: error
    }
}
export const searchNextSuccess = (result) => {
    return {
        type: actionTypes.SEARCH_NEXT_SUCCESS,
        payload: { clips: result }
    }
}

export const searchSetSortDefault = (data) => {
    return {
        type: actionTypes.SEARCH_SET_SORT_DEFAULT,
        payload: data
    }
}

export const searchSetSortOrderDefault = (data) => {
    return {
        type: actionTypes.SEARCH_SET_SORTORDER_DEFAULT,
        payload: data
    }
}


const getSearchFields = (params) => {
    let fields = [];
    Object.keys(params).forEach((f) => {
        if (f !== 'offset' && f !== 'limit' && params[f] != '') {
            let field = f;
            let type = 'contains';
            let value = params[f];
            let use = true;
            let substrFrom = DataUtil.subStringBefore(f, "From");
            let substrTo = DataUtil.subStringBefore(f, "To");
            let substrDate = DataUtil.subStringBefore(f, "CustomDate");
            switch (f) {
                // case 'modelle':
                // case 'tags':
                case 'modelle_ids':
                case 'tags_ids':
                case 'year':
                    value = convertApiString(value);
                    type = 'regexp';
                    use = true;
                    break;
                case 'txt10_ids':
                    let filter = DataUtil.convertStringToArray(value);
                    fields = getSearchFilter(fields, filter);
                    break;
                case `${substrFrom}From`:
                    type = '>=';
                    field = substrFrom;
                    value = changeTimeForSearch(value, "from");
                    use = true;
                    break;
                case `${substrTo}To`:
                    type = '<=';
                    use = true;
                    field = substrTo;
                    value = changeTimeForSearch(value, "to");
                    break;
                case `${substrDate}CustomDate`:
                    type = '=';
                    field = substrDate;
                    use = true;
                    break;
                case 'id':
                    value = updateSearchDataForApps(value);
                    type = 'LIKE';
                    break;
                case 'videolanguage':
                case 'bildformat':
                case 'eingebrannteuntertitel':
                case 'pmdbid':
                case 'txt4':
                case 'createdby':
                    type = '=';
                    use = true;
                    break;
                default:
                    field = f;
                    value = params[f];
            }
            if (use === true) {
                fields.push({ field: field, type: type, value: value });
            }
        }
    });
    fields.push({ field: 'archiv', type: '=', value: 0 });
    return fields;
}


const getSearchFieldsForApps = (params) => {
    let fields = [];
    Object.keys(params).forEach((f) => {
        if (f !== 'offset' && f !== 'limit' && params[f] != '') {
            let field = f;
            let type = 'contains';
            let value = params[f];
            let use = true;
            let substrFrom = DataUtil.subStringBefore(f, "From");
            let substrTo = DataUtil.subStringBefore(f, "To");
            let substrDate = DataUtil.subStringBefore(f, "TemplateDate");

            if (params[f] === 1) type = "=";

            switch (f) {
                case `${substrFrom}From`:
                    type = '>=';
                    field = substrFrom;
                    value = changeTimeForSearch(value, "from");
                    use = true;
                    break;
                case `${substrTo}To`:
                    type = '<=';
                    use = true;
                    field = substrTo;
                    value = changeTimeForSearch(value, "to");
                    break;
                case `${substrDate}TemplateDate`:
                    type = '=';
                    field = substrDate;
                    use = true;
                    break;
                case 'models':
                    value = convertApiString(value);
                    field = 'modelle';
                    type = 'regexp';
                    use = true;
                    break;
                case 'tags':
                    value = convertApiString(value);
                    field = 'tags';
                    type = 'regexp';
                    use = true;
                    break;
                case 'id':
                case 'clipid':
                    value = updateSearchDataForApps(value);
                    type = 'LIKE';
                    break;
                case 'status':
                    type = '=';
                    use = true;
                    break;
                default:
                    field = f;
                    value = params[f];
            }
            if (use === true) {
                fields.push({ field: field, type: type, value: value });
            }
        }
    });
    fields.push({ field: 'archiv', type: '=', value: 0 });

    return fields;
}


const getSearchFilter = (fields, selectedData) => {
    let filter = [...selectedData];
    let maxLength = DataUtil.isNLW() ? 4 : 3;
    if (selectedData.length > 1 && selectedData.length < maxLength) {
        fields.push({ field: '', type: 'BEGIN_OR', value: '' });
    }

    if (DataUtil.isNLW()) {
        let audioIndex = filter.indexOf("audio");
        if (filter.length === 3 && audioIndex === -1) {
            fields = fields.filter(item => item.field !== "media" && item.field !== "");
            fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'audio' });
        }
        if (filter.length > 0 && audioIndex !== -1) {
            if (filter.length > 0 && filter.length < maxLength)
                fields.push({ field: 'media', type: 'CONTAINS', value: 'audio' });

            filter.splice(audioIndex, 1);
        }
    }

    if (filter.length > 0 && filter.length < 3) {
        if (filter.length == 1) {
            if (filter.indexOf('video') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });

                if (selectedData.length > 1 && selectedData.length < maxLength && DataUtil.isNLW())
                    fields.push({ field: '', type: 'END_OR', value: '' });
            }
            if (filter.indexOf('pictures') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                if (selectedData.length > 1 && selectedData.length < maxLength && DataUtil.isNLW())
                    fields.push({ field: '', type: 'END_OR', value: '' });

                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
            }
            if (filter.indexOf('other') > -1) {
                if (DataUtil.isNLW()) {
                    if (selectedData.length > 1 && selectedData.length < maxLength) {
                        fields = fields.filter(item => item.field !== "media" && item.field !== "");
                    } else {
                        fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'audio' });
                    }
                }
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'pictures' });
            }
        } else if (filter.length == 2) {
            if (filter.indexOf('video') > -1 && filter.indexOf('pictures') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                fields.push({ field: '', type: 'END_OR', value: '' });
            }
            if (filter.indexOf('video') > -1 && filter.indexOf('other') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'video' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'other' });
                fields.push({ field: '', type: 'END_OR', value: '' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'pictures' });
            }
            if (filter.indexOf('pictures') > -1 && filter.indexOf('other') > -1) {
                fields.push({ field: 'media', type: 'CONTAINS', value: 'pictures' });
                fields.push({ field: 'media', type: 'CONTAINS', value: 'other' });
                fields.push({ field: '', type: 'END_OR', value: '' });
                fields.push({ field: 'media', type: 'NOT CONTAINS', value: 'video' });
            }
        }
    }
    return fields;
}


export const search = (type, params) => {
    let customSortOption = getSortOptionForSearch(params);
    const clipsPerPage = 50;
    const offset = 0;
    const showArchived = "0";

    return (dispatch, getState) => {
        dispatch(searchStart(type));
        dispatch(actions.resetTickedClips());
        dispatch(actions.resetMultiSelected());

        //Data for SearchNext
        dispatch(actions.setCustomLastSearchType(type));
        const filter = getState().ui.filter;
        const clipListFilter = getState().clipList.filter;
        let customFilter = getState().customData.customCurrentMainFilter;
        if (customFilter && shouldChangeFilterTypes(filter, clipListFilter)) {
            dispatch(actions.setCliplistFilter(filter));
        }

        let configClipInfo = getState().customData.customConfigClipInfoForApp;
        customSortOption.field = DataUtil.getSortOptionsForApp(customSortOption.field, configClipInfo);

        const devices = Object.keys(getState().devices.searchDevices);
        const remoteSearch = (devices.length) ? { remoteserverdevice: devices.join(','), combineremote: true } : {};
        switch (type) {
            case 'fulltext':
                if (getState().customData.customFullTextSearchData) {
                    params.keyword = getState().customData.customFullTextSearchData;
                }

                let fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
                if (filter.length == 0) {
                    dispatch(searchFail('no filter set'));
                    break;
                }
                fields = getSearchFilter(fields, filter);
                window.flow.getClipsByFulltext(params.keyword,
                    {
                        ...remoteSearch,
                        offset: offset,
                        limit: clipsPerPage,
                        fields: fields
                    }).then((result) => {
                        dispatch(actions.getCustomLastSearch({ searchType: 'fulltext', keyword: params.keyword }));
                        dispatch(searchSuccess(result));
                        dispatch(actions.setClipList(null, null));
                    }).catch((res) => {
                        console.log(res);
                        dispatch(searchFail(res.message));
                        dispatch(actions.applicationError(res.message));
                    })
                break;
            case 'byids':
                fields = [{ field: 'id', type: 'IDLIST', value: params.value }, customSortOption];
                window.flow.getClipsByFields(fields, { ...remoteSearch, offset: offset, limit: clipsPerPage }).then((result) => {
                    dispatch(searchSuccess(result));
                    dispatch(actions.setClipList(null, null));
                }).catch((res) => {
                    console.log(res);
                    dispatch(searchFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;
            case 'byfields':
                saveSearchInfo(dispatch, "Starting", " ", 'SearchClipByFieldsStart');
                saveSearchInfo(dispatch, params, " ", 'Searchdata');
                if (process.env.REACT_APP_APPID === 'PMDB') fields = getSearchFields(params);
                else fields = getSearchFieldsForApps(params);

                if (DataUtil.isPMDB()) {
                    fields = fields.filter(item => item.field !== 'txt10' && item.field !== 'txt10_ids' && item.field !== 'customCurrentSortOption');
                } else fields = fields.filter(item => item.field !== 'customCurrentSortOption');

                dispatch(actions.setCustomLastByFieldsData([...fields]));
                fields.push({ field: 'archiv', type: '=', value: showArchived }, customSortOption);
                // console.log("LAMTEST SEARCH fields", fields);
                saveSearchInfo(dispatch, fields, " ", 'SearchClipByFields');
                window.flow.getClipsByFields(fields, { ...remoteSearch, offset: offset, limit: clipsPerPage }).then((result) => {
                    dispatch(actions.getCustomLastSearch({ searchType: 'byfields', params: params }));
                    dispatch(searchSuccess(result));
                    saveSearchInfo(dispatch, result, " ", 'SearchClipByFieldsStatus');
                    if (result.objects && result.objects.elements) saveSearchInfo(dispatch, result.objects.elements, " ", 'SearchClipByFieldsElements');
                    dispatch(actions.setClipList(null, null));
                }).catch((res) => {
                    console.log(res);
                    dispatch(searchFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;
            case 'latestvideos':
                fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
                fields = getSearchFilter(fields, ['video']);
                window.flow.getClipsByFulltext(params.keyword,
                    {
                        offset: 0,
                        limit: 16,
                        fields: fields
                    }).then((result) => {
                        dispatch(searchSuccess(result, type));
                        dispatch(actions.setClipList(null, null));
                    }).catch((res) => {
                        console.log(res);
                        dispatch(searchFail(res.message));
                        dispatch(actions.applicationError(res.message));
                    });

                break;
            case 'latestpictures':
                fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
                fields = getSearchFilter(fields, ['pictures']);
                window.flow.getClipsByFulltext(params.keyword,
                    {
                        offset: 0,
                        limit: 16,
                        fields: fields
                    }).then((result) => {
                        dispatch(searchSuccess(result, type));
                        dispatch(actions.setClipList(null, null));
                    }).catch((res) => {
                        console.log(res);
                        dispatch(searchFail(res.message));
                        dispatch(actions.applicationError(res.message));
                    });

                break;
            default:
                dispatch(searchFail('Can do only fulltext search at the moment.'));
                dispatch(actions.applicationError('Can do only fulltext search at the moment.'));
        }
    }
}

export const searchNext = (type, params) => {
    let customSortOption = getSortOptionForSearch(params);
    const clipsPerPage = 50;
    let offset = params.offset ? params.offset : 0;
    let showArchived = '0';
    return (dispatch, getState) => {
        dispatch(searchNextStart());
        if (getState().customData.customLastSearchType === "byfields") type = "byfields";
        const filter = getState().ui.filter;
        const devices = Object.keys(getState().devices.searchDevices);
        const remoteSearch = (devices.length) ? { remoteserverdevice: devices.join(','), combineremote: true } : {};

        let configClipInfo = getState().customData.customConfigClipInfoForApp;
        customSortOption.field = DataUtil.getSortOptionsForApp(customSortOption.field, configClipInfo);

        switch (type) {
            case 'fulltext':
                if (getState().customData.customFullTextSearchData) {
                    params.keyword = getState().customData.customFullTextSearchData;
                }
                let fields = [{ field: 'archiv', type: '=', value: showArchived }, customSortOption];
                if (filter.length == 0) {
                    dispatch(searchFail('no filter set'));
                    break;
                }
                fields = getSearchFilter(fields, filter);
                // console.log("LAMTEST SEARCH_NEXT FULLTEXT fields params.keyword", fields, params.keyword);
                window.flow.getClipsByFulltext(params.keyword, {
                    ...remoteSearch,
                    offset: offset,
                    limit: clipsPerPage,
                    fields: fields
                }).then((result) => {
                    dispatch(searchNextSuccess(result));
                }).catch((res) => {
                    console.log(res);
                    dispatch(searchNextFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;
            case 'byfields':
                if (getState().customData.customLastByFieldsData) {
                    fields = getState().customData.customLastByFieldsData;
                    fields = fields.filter(obj => obj.field !== "archiv");
                } else fields = getSearchFields(params);

                fields.push({ field: 'archiv', type: '=', value: showArchived }, customSortOption);
                // console.log("LAMTEST SEARCH_NEXT BYFIELDS fields", fields);
                window.flow.getClipsByFields(fields, { ...remoteSearch, offset: offset, limit: clipsPerPage }).then((result) => {
                    dispatch(searchNextSuccess(result));

                }).catch((res) => {
                    console.log(res);
                    dispatch(searchNextFail(res.message));
                    dispatch(actions.applicationError(res.message));
                })
                break;

            default:
                dispatch(searchNextFail('Can do only fulltext search at the moment.'));
                dispatch(actions.applicationError('Can do only fulltext search at the moment.'));
        }

    }
}
